/**
 * @fileoverview Renders styled breadcrumbs (using 'react-breadcrumbs' module) from received props
 */

import React from 'react'
import StyledBreadcrumbs from '../StyledBreadcrumbs'

/**
 * Returns generated react component that contains rendered breadcrumbs based on received props
 *
 * @param {JSX.Element} props.icon Icon that will be displayed before first breadcrumb
 * @param {array<Object>} props.items Array of breadcrumbs that we want to render
 *
 * @param {string} props.items[].title Name of the path that will be displayed to the user
 * @param {string} props.items[].pathname URL that will be used for redirect on click
 *
 * @returns JSX.Element
 *
 * @example
 *  <BreadcrumbsRenderer
 *    icon={<Icon />}
 *    items={[{ label:'Campaigns', link: '/dashboard/campaigns' }]}
 *  />
 */
const BreadcrumbsRenderer = ({ icon, items }) => {
  return (
    <React.Fragment>
      <StyledBreadcrumbs icon={icon} breadcrumbs={items} />
    </React.Fragment>
  )
}

export default BreadcrumbsRenderer
